import * as React from "react"
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image"
import SideQuoteForm from "../layout/SideQuoteForm"
import { getGatsbyImageHero } from "../../helpers/GatsbyImageHelper"
import Section from "./Section"
import { IconChevronLeft } from "../icons/Icons"
import { Helmet } from "react-helmet"
import AboutUsVideo from "./AboutUsVideo"

const CmsPageContent = ({ page }) => {
  const blocks = page?.blocks
  const [expandForm, setExpandForm] = React.useState(false)
  const [focused, setFocused] = React.useState(false)

  React.useEffect(() => {
    if (focused) {
      setTimeout(() => {
        setFocused(false)
      }, 2000)
    }
  }, [focused])

  return (
    <section className="relative w-full px-5 xl:px-0 xl:w-10/12 xl:max-w-[1366px] mx-auto flex flex-col lg:flex-row ">
      {focused && (
        <div className="animate-fade-in fixed inset-0 z-10 bg-black/20 backdrop-blur-sm flex justify-center items-center"></div>
      )}
      {expandForm && (
        <div className="hidden lg:block fixed inset-0 bg-black/20 backdrop-blur-sm z-50"></div>
      )}
      <div className={" duration-300 order-2 lg:order-1 z-0 w-full lg:w-2/3 lg:pr-5"}>
        <div className={" w-full flex flex-col"}>
          <div
            className={
              (page.hero_image_url || page.hero_image?.url
                ? "grid-cols-1 lg:grid-cols-2 "
                : "  grid-cols-1") +
              " grid grid-rows-1 lg:grid-rows-1 bg-center bg-fixed w-full lg:col-span-2 "
            }
          >
            {(page.hero_image_url || page.hero_image?.url) && (
              <div className={" h-full w-full overflow-hidden rounded-2xl"}>
                <GatsbyImage
                  alt={page.meta_title}
                  className={
                    "h-full w-full object-cover  aspect-video hover:scale-105 duration-300 ease-in-out"
                  }
                  image={getImage(getGatsbyImageHero(page.hero_image_url || page.hero_image.url))}
                />
              </div>
            )}

            <div
              className={
                (page.hero_image_url || page.hero_image?.url
                  ? "w-full lg:w-10/12 py-5 lg:py-0"
                  : "w-full py-10 ") + " mx-auto flex flex-col xl:justify-between "
              }
            >
              <p className="text-sm text-gray-500">{page.updated_at_formatted}</p>
              <h1 className=" text-3xl font-black ">{page.title}</h1>
              {(page.hero_image_url || page.hero_image?.url) && (
                <button
                  onClick={() => setFocused(true)}
                  className="hidden xl:block m-3 px-5 py-2 text-white font-bold bg-accent hover:bg-accentMd duration-200 ease-in-out rounded-lg"
                >
                  GET QUOTE
                </button>
              )}
            </div>
          </div>
          {/* <a href={"#form"} className="btn-cta my-2 p-2 lg:hidden mx-4">
            Get Your Free Quote
          </a> */}
          <hr className="w-10/12 mx-auto bg-gray-600 my-5" />
          <section
            className={
              " w-full order-1 lg:grid-cols-1 lg:grid-rows-2 overflow-x-hidden duration-300"
            }
          >
            <section className={"cms md:mx-auto"} dangerouslySetInnerHTML={{ __html: page.html }} />
            {blocks.length > 0
              ? blocks.map(block => (
                  <Section key={`${block.strapi_component}-${block.id}`} section={block} />
                ))
              : null}
            <section className="flex w-full flex-col justify-center py-10">
              <div className="flex w-full flex-col items-center justify-center ">
                <AboutUsVideo />
                <a
                  href="tel:+13057706955"
                  className="text-3xl font-bold text-accent hover:text-gray-500"
                >
                  <h2 className="px-10 text-center text-3xl uppercase">
                    <a href={"tel:+13057706955"}>Call Us Now: 305 770 6955</a>
                  </h2>
                </a>
                <br />
                <div className="w-full shadow-xl"> &nbsp;</div>
                <h2 className="py-10 uppercase text-gray-800 text-center">
                  The Purchasing and Consignment Division of Gray &amp; Sons <br />
                </h2>
                <br />
                <a href="https://www.grayandsons.com/catalog-request">
                  <StaticImage
                    src={"../../images/svg/gray-and-sons-logo.svg"}
                    alt={"Gray and Sons Jewelers"}
                  />
                </a>
                <br /> <br /> <br />
                <h2 className="w-full text-center text-2xl font-black uppercase py-10">
                  Be the first to know | SEE OUR CATALOG
                </h2>
                <a
                  href="https://www.grayandsons.com/catalog-request"
                  className="flex w-full justify-center"
                >
                  <StaticImage
                    src={"../../images/gray-and-sons-request-catalog-banner.jpeg"}
                    alt={"Gray and Sons Catalog Subscription"}
                  />
                </a>
              </div>
            </section>
          </section>
        </div>
      </div>

      {/* Form that expands and contracts */}
      <div
        className={
          (expandForm
            ? "lg:w-[80vw] lg:fixed lg:right-[10vw] lg:top-[12.5vh] lg:z-50"
            : " lg:sticky w-full lg:w-1/3 lg:min-w-[450px]") +
          "  duration-300 ease-out order-1 lg:order-2 top-5 z-30"
        }
      >
        <div className={"md:sticky top-0 "}>
          <div
            onClick={() => {
              setExpandForm(true)
            }}
            className={
              (expandForm
                ? //? "h-[47rem] sm:h-[35rem] lg:h-full"
                  "lg:h-full  "
                : "h-[4rem] lg:h-full overflow-clip lg:overflow-auto shadow-md ") +
              "relative mt-10 md:mt-0  duration-150 mb-3 "
            }
          >
            <SideQuoteForm expandForm={expandForm} />
            <Helmet bodyAttributes={{ class: expandForm ? "lg:overflow-hidden" : "" }} />

            <p
              className={
                (expandForm ? "hidden" : "block: lg:hidden") +
                " absolute w-full top-0 text-center uppercase text-accentMd text-base"
              }
            >
              click here to <br />
            </p>
          </div>
          {expandForm ? (
            <button
              onClick={() => {
                setExpandForm(false)
              }}
              className="absolute top-12 md:top-3 left-6 md:left-3 z-40"
            >
              <div className=" w-10 h-10 grid grid-cols-2 grid-rows-2 gap-0 relative group text-gray-500 hover:text-accentMd p-2 hover:p-3 ">
                <IconChevronLeft className="rotate-45 -translate-y-1 -translate-x-1 duration-200 group-hover:rotate-[225deg] group-hover:translate-x-0 group-hover:translate-y-0 pointer-events-none" />
                <IconChevronLeft className="rotate-[135deg] translate-x-1 -translate-y-1 duration-200 group-hover:rotate-[-45deg] group-hover:translate-x-0 group-hover:translate-y-0 pointer-events-none" />
                <IconChevronLeft className="rotate-[-45deg] -translate-x-1 translate-y-1 duration-200 group-hover:rotate-[135deg] group-hover:translate-x-0 group-hover:translate-y-0 pointer-events-none" />
                <IconChevronLeft className="rotate-[225deg] translate-x-1 translate-y-1 duration-200 group-hover:rotate-[45deg] group-hover:translate-x-0 group-hover:translate-y-0 pointer-events-none" />
              </div>
            </button>
          ) : (
            <button
              onClick={() => {
                setExpandForm(true)
              }}
              className="absolute top-12 md:top-3 left-6 md:left-3 z-40"
            >
              <div className="w-10 h-10 grid grid-cols-2 grid-rows-2 gap-0 relative group text-gray-500 hover:text-accentMd p-3 hover:p-2">
                <IconChevronLeft className="rotate-[225deg] group-hover:rotate-45 group-hover:-translate-x-1 group-hover:-translate-y-1 duration-200 pointer-events-none" />
                <IconChevronLeft className="rotate-[-45deg] group-hover:rotate-[135deg] group-hover:translate-x-1 group-hover:-translate-y-1 duration-200 pointer-events-none" />
                <IconChevronLeft className="rotate-[135deg] group-hover:rotate-[-45deg] group-hover:-translate-x-1 group-hover:translate-y-1 duration-200 pointer-events-none" />
                <IconChevronLeft className="rotate-45 group-hover:rotate-[225deg] group-hover:translate-x-1 group-hover:translate-y-1 duration-200 pointer-events-none" />
              </div>
            </button>
          )}
        </div>

        {/* <button
          onClick={() => {
            setExpandForm(false)
          }}
          className="absolute top-0 left-0 w-8 h-8 bg-black hover:bg-red-300"
        >
          <div>
            <IconChevronLeft />
          </div>
        </button> */}
      </div>
    </section>
  )
}

export default CmsPageContent
